import React from 'react'
import PropTypes from 'prop-types'

import CsvButton from 'shared/components/buttons/CsvButton'
import { Dropdown } from 'react-bootstrap'
import classnames from 'classnames'
import './style.scss'

const SizePerPageDropdown = ({ options, currentSize, onSizePerPageChange }) => {
  return (
    <Dropdown>
      <Dropdown.Toggle variant="dark" size="sm" id="size-per-page-dropdown">
        {currentSize}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {options.map(size => (
          <Dropdown.Item
            key={size}
            active={size === currentSize}
            onClick={() => onSizePerPageChange(size)}
          >
            {size}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

const BaseTableHeader = props => {

  const getTableSize = (paginationProps, recordsSize = undefined) => {
    const getDefaultSize = () => {
      const totalSize = recordsSize || paginationProps.totalSize
      return paginationProps.dataSize === paginationProps.totalSize
        ? paginationProps.totalSize
        : `${paginationProps.dataSize}/${totalSize}`
    }

    switch (props.resourceConstant) {
      case 'HPD_COMPLAINT': {
        if (!props.records || !Array.isArray(props.records)) {
          // Records not loaded yet
          return <span className="text-start">Data not available</span>;
        }

        const uniqueComplaintIds = new Set(props.records.map(record => record.complaintid));
        const totalUniqueComplaints = uniqueComplaintIds.size;
        const totalProblems = props.records.length;

        return (
          <span className="text-start">
            <div>
              Total Complaints: {totalUniqueComplaints}
            </div>
            <div>
              Total Problems: {totalProblems}
            </div>

          </span>
        );
      }

      case 'DOB_ISSUED_PERMIT': {
        return <span>Total: {recordsSize}</span>
      }

      default:
        return <span>Total: {getDefaultSize()}</span>
    }
  }

  return (
    <div className={classnames('base-table-header', props.headerClass)}>
      <div className="base-table-header__wrapper">
        {getTableSize(props.paginationProps, props.recordsSize)}
        <div className="base-table__select-filters">
          {props.filterButtonSets.map((set, index) => {
            return (
              <div className="base-table__select-filters__container" key={`button-set${index}`}>
                {set(props.selectedFilters)}
              </div>
            )
          })}
        </div>
        <div className="base-table-header__right-group">
          <div className="table-header__share-column">
            <CsvButton
              onClick={props.handleCsvClick}
              csvProps={props.csvProps}
              size="sm"
            />
          </div>
          {props.recordsSize > 10 && (
            <div className="table-header__pagination_dropdown">
              <SizePerPageDropdown
                options={props.sizePerPageOptions || [10, 50, 100]}
                currentSize={props.paginationProps.sizePerPage}
                onSizePerPageChange={props.onSizePerPageChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

BaseTableHeader.propTypes = {
  csvProps: PropTypes.object,
  paginationProps: PropTypes.object,
  recordsSize: PropTypes.number,
  handleCsvClick: PropTypes.func,
  resourceConstant: PropTypes.string,
  records: PropTypes.array,
  request: PropTypes.object,
  filterButtonSets: PropTypes.array,
  selectedFilters: PropTypes.object,
  sizePerPageOptions: PropTypes.array,
  onSizePerPageChange: PropTypes.func,
}
BaseTableHeader.defaultProps = {
  csvProps: {},
  records: [],
  filterButtonSets: [],
  selectedFilters: {},
  sizePerPageOptions: [10, 50, 100],
}

export default BaseTableHeader
